import React from "react";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { colors, sizes } from "assets/constants";
import css from "styles";
import fonts from "assets/fonts";

import BaseInfo from "../base-info";
import CreditInfo from "../credit-info";
import AttacheInfo from "../attache-info";
import SupplementInfo from "../supplement-info";

export const tabs = [
  { title: "اطلاعات پیوست", name: "ATTACHE", component: AttacheInfo },
  { title: "اطلاعات اعتبار", name: "CREDIT", component: CreditInfo },
  { title: "اطلاعات تکمیلی", name: "SUPPLEMENT", component: SupplementInfo },
  { title: "اطلاعات پایه", name: "BASE", component: BaseInfo },
];

const Tab = createMaterialTopTabNavigator();

export default function Tabs(props: { data: object }) {
  const { data } = props;
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <Tab.Navigator
      pageMargin={5}
      backBehavior="none"
      initialRouteName={"BASE"}
      screenOptions={() => ({
        tabBarScrollEnabled: true,

        tabBarPressColor: "transparent",

        tabBarActiveTintColor: color,

        tabBarInactiveTintColor: colors.textColorGray,

        tabBarContentContainerStyle: {
          flexGrow: 1,
          justifyContent: "flex-end",
        },

        tabBarStyle: { ...css.removeGaps, elevation: 1 },

        tabBarItemStyle: {
          width: "auto",
          alignItems: "center",
          justifyContent: "center",
          ...css.removeGaps,
          paddingLeft: sizes.space,
          paddingRight: sizes.space,
        },

        tabBarLabelStyle: {
          ...css.removeGaps,
          fontFamily: fonts.fa.default,
          textAlignVertical: "center",
        },

        tabBarIndicatorStyle: {
          height: 3,
          ...css.removeGaps,
          borderBottomLeftRadius: 200,
          borderBottomRightRadius: 200,
        },

        tabBarIndicator: () => null,
      })}
    >
      {tabs?.map((item, i) => (
        <Tab.Screen
          key={i + ""}
          name={item?.name}
          initialParams={{ data }}
          component={item.component}
          options={{ title: item.title }}
        />
      ))}
    </Tab.Navigator>
  );
}
